/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { marketIndustryDtoSchema } from "./marketIndustryDtoSchema.ts";
import { marketSegmentationDtoSchema } from "./marketSegmentationDtoSchema.ts";
import { marketSizeDtoSchema } from "./marketSizeDtoSchema.ts";
import { z } from "zod/v4";

export const marketSectionDtoSchema = z.object({
  get industry() {
    return marketIndustryDtoSchema.optional();
  },
  get marketSize() {
    return marketSizeDtoSchema.optional();
  },
  get segmentation() {
    return marketSegmentationDtoSchema.optional();
  },
});
